import { useCallback } from "react";

import { queryClient } from "../../../services/query";

import { fieldCropsQueryKeyPrefix } from "./fieldCrops.query";

// #############################
// ## useInvalidateFieldCrops ##
// #############################

export type ResultOfUseInvalidateFieldCrops = () => Promise<void>;
export type UseInvalidateFieldCrops = () => ResultOfUseInvalidateFieldCrops;

/**
 * Invalidates the field crops data.
 */
export const useInvalidateFieldCrops: UseInvalidateFieldCrops = () => {
  return useCallback(async () => {
    await queryClient.invalidateQueries(fieldCropsQueryKeyPrefix);
  }, []);
};

// ########################
// ## useClearFieldCrops ##
// ########################

export type ResultOfUseClearFieldCrops = () => Promise<void>;
export type UseClearFieldCrops = () => ResultOfUseClearFieldCrops;

/**
 * Clears and invalidates the field crops data.
 * A fresh fetch of data will be initiated when a hook instance is active that uses this data.
 */
export const useClearFieldCrops: UseClearFieldCrops = () => {
  return useCallback(async () => {
    await queryClient.resetQueries(fieldCropsQueryKeyPrefix);
  }, []);
};
